import React from 'react';

export default function HastagIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="m15 22.75h-6c-5.43 0-7.75-2.32-7.75-7.75v-6c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.57-2.18 7.75-7.75 7.75m0-1.5c4.61 0 6.25-1.5 6.25-6.25v-6c0-4.61-1.64-6.25-6.25-6.25h-6c-4.61 0-6.25 1.64-6.25 6.25v6c0 4.61 1.64 6.25 6.25 6.25h6zm-5.1003-3.7599c-.03 0-.06 0-.08 0-.41-.05-.71-.42-.66-.83l1.04-9.48c.05-.41.41-.71.83-.66.41.05.71.42.66.83l-1.05 9.47c-.0399.38-.37.67-.74.67zm3.1504-.0002c-.03 0-.06 0-.08 0-.41-.05-.71-.42-.66-.83l1.05-9.47c.05-.41.42-.71.83-.66.41.05.71.42.66.83l-1.05 9.47c-.04.37-.37.66-.75.66zm3.9492-6.32h-9.47c-.41 0-.75-.34-.75-.75 0-.41.34-.75.75-.75h9.47c.41 0 .75.34.75.75 0 .41-.34.75-.75.75zm-.5293 3.1602h-9.47c-.41 0-.75-.34-.75-.75 0-.41.34-.75.75-.75h9.47c.41 0 .75.34.75.75 0 .41-.33.75-.75.75z"
        fill="currentColor"
      />
    </svg>
  );
}
